module.exports = __webpack_public_path__ + "img/ezship_logo.7c086b0c.gif";